import { createContext, useContext, useEffect } from "react";
import query from "../server/constants.api";
import useFetch from "../server/useFetch";
import { useAuthContext } from "./AuthContext";

const GlobalDataContext = createContext();

export const useGlobalData = () => {
    return useContext(GlobalDataContext);
};

export const GlobalDataProvider = ({ children }) => {
    const { tenant } = useAuthContext();

    /**
     * Api to call incidents properties for create incident modal
     */
    const {
        data: incidentPropertiesData,
        isFetching: isFetchingIncidentProperties,
        refetch: refetchIncidentProperties,
    } = useFetch(
        query.path.getIncidentProperties,
        "getIncidentProperties",
        {
            tenant: tenant,
        },
        false,
        "GET",
        query.commandMiddlewareURL
    );

    /**
     * Api to call generic services for city services, when clicking in the map 
     */
    const {
        data: genericItemsData,
        isFetching: isFetchingGenericItems,
        refetch: refetchGenericItems,
    } = useFetch(
        query.path.getItems,
        "getGenericItemsForIncident",
        {
            tenant: tenant,
            generic: true,
        },
        false,
        "GET",
        query.middlewareURL
    )

    /**
     * Api to call incident categories for create incident modal
     * For the MiCo case, does not change the result
     * So we send the class as MiCo, is indifferent 
     */
    const {
        data: incidentCategoriesData,
        isFetching: isFetchingIncidentCategories,
        refetch: refetchIncidentCategories,
    } = useFetch(
        query.path.getIncidentCategories,
        "getIncidentCategories",
        {
            tenant: tenant,
            class: "MiCo"
        },
        false,
        "GET",
        query.commandMiddlewareURL
    );

    /**
     * UseEffect to refetch incident properties and generic items when tenant changes
     */
    useEffect(() => {
        if (tenant) {
            refetchIncidentProperties();
            refetchGenericItems();
            refetchIncidentCategories();
        }
    }, [tenant]);

    return (
        <GlobalDataContext.Provider value={{
            incidentPropertiesData, isFetchingIncidentProperties, genericItemsData, isFetchingGenericItems,
            incidentCategoriesData, isFetchingIncidentCategories,
        }}>
            {children}
        </GlobalDataContext.Provider>
    );
};